import { action } from 'typesafe-actions';

import { IExportItem } from 'APIPackage/ImportExportModule/interfaces/IExportItem';

import { ExportActionsEnum } from '../enums/ExportActionsEnum';
import { IExportRow } from '../interfaces/IExportRow';

export const exportInitPage = () => action(ExportActionsEnum.EXPORT_INIT_PAGE);
export const exportGetData = () => action(ExportActionsEnum.EXPORT_GET_DATA);
export const exportGetDataNextPage = () => action(ExportActionsEnum.EXPORT_GET_DATA_NEXT_PAGE);
export const exportSetData = (data: IExportRow[], page: number, pageCount: number, totalCount: number) =>
  action(ExportActionsEnum.EXPORT_SET_DATA, { data, page, pageCount, totalCount });
export const exportSetOrder = (order: string | null) => action(ExportActionsEnum.EXPORT_SET_ORDER, { order });
export const exportRemove = (removedIds: number[]) => action(ExportActionsEnum.EXPORT_REMOVE, { removedIds });
export const exportDownloadFile = (id: IExportItem['id'], filename: IExportItem['filename']) =>
  action(ExportActionsEnum.EXPORT_DOWNLOAD_FILE, { id, filename });
